// The per-company "Public ledger signatories" team (GOVERNANCE). The server creates it and keeps its members in step with
// the company's signature rule; team-save and team-delete refuse to change it, so the client shows it read-only.

export interface SignatoriesTeamCompany {
  ledgerCred?: { signatoriesTeamId?: string | null } | null;
}

/** Whether a team is the company's public ledger signatories team. */
export function isSignatoriesTeam(
  teamId: string | null | undefined,
  company: SignatoriesTeamCompany | null | undefined,
) {
  const signatoriesTeamId = company?.ledgerCred?.signatoriesTeamId;
  return !!teamId && !!signatoriesTeamId && teamId === signatoriesTeamId;
}
